import {TagRead, JobRead} from "../schemas";

export const JOB_ADDED = 'jobAdded'

export interface JobAddedEventDetail {
    job?: JobRead;
    newFolder?: TagRead;  // Folder is now a TagRead with type=FOLDER_UPLOAD
}

export const TAG_UPDATE_COMPLETED = 'tagUpdated'

export interface TagUpdatedEventDetail {
    tagIds: string[];
}

export const DOCUMENT_UPLOAD_COMPLETED = 'documentUploadCompleted'

export interface DocumentUploadCompletedEventDetail {
    documentIds: string[];
}

export const PRODUCTION_COMPLETED = 'productionCompleted'

export interface ProductionCompletedEventDetail {
    productionIds: string[];
}

export const INVESTIGATION_COMPLETED = 'investigationCompleted'

export interface InvestigationCompletedEventDetail {
    groupId: string;
    tagIds: string[];
}

export const SEED_COMPLETED = 'seedCompleted'

export interface SeedCompletedEventDetail {
    groupId: string;
}